'use strict';

export const cdsBaseURL = 'http://cloud.agroclimate.org/api/cds/v2';
export const spatialBaseURL = '';
export const xApiKey = './AE3C6B65A20C9F1B651FEEA6443FE63B5E3C6B65A20C9F1B651FEEA6443FE$';
export const authURL = 'https://my.agroclimate.org/sso';
export const authLogoutURL = 'https://my.agroclimate.org/lout';

// Tool's specifics
export const anthracnoseID = '59a81dee707cbe4640bfa8fd';
export const botrytisID = '59a81be7707cbe4640bfa8fb';
export const commodityID = '59a81aaf707cbe4640bfa8f5';
// export const toolURL = 'http://localhost:4200/tools/sas';
export const toolURL = 'http://agroclimate.org/tools/sas';
